import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../store/applicationState';
import { setSideBar } from '../../store/sidebar/actions';
import { GetWebinarCertificate } from '../../store/sockets/actions';
import { TYPE_EVENT, TYPE_ID } from '../../utils/consts';
import { EIcons } from '../../utils/globatTypes';
import { CertificateModal, MyTicket, SimpleModal } from '../modals';
import { IconCertificate } from '../svgs/IconCertificate';
import { IconLogo } from '../svgs/IconLogo';
import { Spinner } from '../ui/Spinner';
import * as SBStyles from './styles';
import { setVideoHide } from '../../store/video/actions';
import { useActionsMarketing } from '../../hooks/useActionsMarketing';

interface IItemMenu {
  name: string;
  icon: string;
  active: boolean;
  isVebinar?: boolean;
  subMenu?: { name: string; url: string }[];
}

interface indexProps {}

export const Sidebar: React.FC<indexProps> = () => {
  const [menu, setMenu] = React.useState<IItemMenu[] | null>(null);
  const [ticketModal, setTicketModal] = React.useState(false);
  const [isWebinarCert, setIsWebinarCert] = React.useState(false);
  const [certificateModal, setCertificatModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const { Sidebar, Users, Sockets, FinalTest } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  const { clickCerteficate } = useActionsMarketing();

  React.useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;
    const { event, room } = Sockets;
    if (Users.user && !Users.error) {
      const list = [{ name: `Головна`, icon: EIcons.home, active: true }];
      setMenu(list);

      if (event && room && ![TYPE_ID.WEBINAR, TYPE_ID.VIDEO_TARNING].includes(event.type_id)) {
        const isStart = Date.parse(event.dateStart) < Number(new Date());
        const list = [] as IItemMenu[];

        if (event.typeEvent === TYPE_EVENT.ONLINE) {
          list.push({ name: 'Учасники', icon: EIcons.group, active: true });
          list.push({ name: 'Приватний чат', icon: EIcons.chat, active: true });
          list.push({ name: 'Інтерактив', icon: EIcons.interactive, active: true });
        }

        if (event.urlAbout) {
          list.push({
            name: `<a href="${event.urlAbout}" target="_blank" rel="noreferrer">Про захід</a>`,
            icon: EIcons.about,
            active: true,
          });
        }

        if (event.urlAnketa) {
          if (isStart) {
            list.push({
              name: `<a href="${event.urlAnketa}" target="_blank" rel="noreferrer">Анкета учасника</a>`,
              icon: EIcons.anketa,
              active: isStart,
            });
          } else {
            list.push({ name: `Анкета учасника`, icon: EIcons.anketa, active: isStart });
          }
        }

        if (room.urlAddInfo) {
          list.push({
            name: `<a href=${room.urlAddInfo} target="_blank" rel="noreferrer">Додаткові матеріали</a>`,
            icon: EIcons.addFile,
            active: true,
          });
        }

        if (event.isTicket && event.typeEvent === TYPE_EVENT.OFFLINE) {
          list.push({ name: `Квиток на захід`, icon: EIcons.ticket, active: true });
        }

        if (event.isCertificate === 1 && [TYPE_ID.SEMINAR, TYPE_ID.SCHOOL].includes(event.type_id)) {
          list.push({ name: 'Мій сертифікат', icon: EIcons.certificate, active: true });
        }

        if (event.urlHelp) {
          list.push({
            name: `<a href=${event.urlHelp} target="_blank" rel="noreferrer">Технічні підказки</a>`,
            icon: EIcons.help,
            active: true,
          });
        }

        if (FinalTest.data) {
          list.push({ name: `Фiнальний тест`, icon: EIcons.final, active: true });
        }

        if (room.docs?.length) {
          list.push({ name: `Презентації та файли до заходу`, icon: EIcons.presentation, active: false, subMenu: room.docs });
        }

        setMenu((prevState) => (prevState ? [...prevState, ...list] : list));
      }

      if (event && [TYPE_ID.WEBINAR, TYPE_ID.VIDEO_TARNING].includes(event.type_id) && Users.user.isRegister) {
        const items = [] as any[];
        const isStart = Date.parse(event.dateStart) < Number(new Date());
        const main = { name: `Головна`, icon: EIcons.home, active: true, isVebinar: false };
        const myCertificate = {
          name: 'Мій сертифікат',
          icon: EIcons.certificate,
          active: true,
          isVebinar: true,
        };
        const myFinalTest = {
          name: `Фiнальний тест`,
          icon: EIcons.final,
          active: true,
          isVebinar: false,
        };

        items.push(main);

        if (event.isWebinarCertificate) {
          items.push(myCertificate);
        }

        if (TYPE_ID.WEBINAR === event.type_id) {
          items.push({ name: 'Інтерактив', icon: EIcons.interactive, active: true });
        }

        if (TYPE_ID.WEBINAR === event.type_id && FinalTest.data) {
          setMenu([main, myFinalTest]);
          items.push(myFinalTest);
        }

        if (TYPE_ID.WEBINAR === event.type_id && room && isStart) {
          if (room.docs?.length) {
            items.push({ name: `Презентації та файли до заходу`, icon: EIcons.presentation, active: false, subMenu: room.docs });
          }
        }

        if (new Date(new Date(event.dateStart).getTime() + 1000 * 60 * 60) < new Date()) {
          setMenu(items);
        } else {
          intervalId = setInterval(() => {
            if (Sockets.event && new Date(new Date(Sockets.event.dateStart).getTime() + 1000 * 60 * 60) < new Date()) {
              setMenu(items);
              intervalId && clearInterval(intervalId);
            }
          }, 1000);
        }
      }
      return () => {
        if (intervalId) {
          return clearInterval(intervalId);
        }
      };
    }
  }, [Sockets, Users, FinalTest.data]);

  const handleClickCertificate = (itm: IItemMenu) => {
    clickCerteficate();
    if (itm.icon === EIcons.certificate && !itm.isVebinar) {
      setCertificatModal(true);
    }
    if (itm.icon === EIcons.certificate && itm.isVebinar && Sockets.event && !loading) {
      if (FinalTest.data && !FinalTest.data?.isDone && Sockets.event.type_id === TYPE_ID.WEBINAR) {
        return setIsWebinarCert(true);
      }
      setLoading(true);
      dispatch(
        GetWebinarCertificate.request({
          data: {
            event_id: Sockets.event?.absnum,
          },
          callBack: () => setLoading(false),
        })
      );
    }
  };

  return (
    <>
      <SBStyles.WrapperS>
        <SBStyles.LogoWrapperS>
          <div>
            <IconLogo />
            <span>
              Експертус
              <br />
              медіа
            </span>
          </div>
        </SBStyles.LogoWrapperS>
        <SBStyles.NavS>
          {menu &&
            menu.map((itm) => (
              <React.Fragment key={itm.icon}>
                <SBStyles.NavItemS
                  onClick={() => {
                    if (
                      itm.icon === EIcons.group ||
                      itm.icon === EIcons.chat ||
                      itm.icon === EIcons.home ||
                      itm.icon === EIcons.interactive ||
                      itm.icon === EIcons.final
                    ) {
                      itm.active && dispatch(setSideBar(itm.icon));
                    }
                    itm.name === `Квиток на захід` && setTicketModal(true);
                    if (itm.icon === EIcons.certificate) {
                      handleClickCertificate(itm);
                    }
                    if (itm.icon === EIcons.final) {
                      dispatch(setVideoHide(true));
                    }
                  }}
                  hover={itm.active}
                  active={itm.active && itm.icon === Sidebar.name}
                >
                  {itm.icon === EIcons.certificate ? (
                    loading ? (
                      <Spinner color="rgba(255, 255, 255, 0.45)" size={5} />
                    ) : (
                      <IconCertificate />
                    )
                  ) : (
                    <i className={itm.icon} />
                  )}
                  <span dangerouslySetInnerHTML={{ __html: itm.name }} />
                </SBStyles.NavItemS>
                {itm.subMenu ? (
                  <ul style={{ paddingLeft: '60px', display: 'none' }}>
                    {itm.subMenu.map((subItem, i) => (
                      <SBStyles.NavItemS
                        key={i}
                        hover={true}
                        dangerouslySetInnerHTML={{
                          __html: `<a href="${subItem.url}" target="_blank" rel="noreferrer"${
                            ['txt', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(subItem.url?.substring(subItem.url.lastIndexOf('.') + 1))
                              ? `download="${subItem.name}"`
                              : ''
                          }>
                          ${subItem.name}
                        </a>`,
                        }}
                      />
                    ))}
                  </ul>
                ) : null}
              </React.Fragment>
            ))}
          {ticketModal ? <MyTicket closeHandler={() => setTicketModal(false)} /> : null}
          {certificateModal && Sockets.event ? (
            <CertificateModal groupId={Sockets.event.group_id} closeHandler={() => setCertificatModal(false)} />
          ) : null}
          {isWebinarCert ? (
            <SimpleModal
              text="Вітаю! Персональний сертифікат, що підтверджує участь у події буде доступний Вам після проходження фінального тесту"
              closeHandler={() => setIsWebinarCert(false)}
            />
          ) : null}
        </SBStyles.NavS>
      </SBStyles.WrapperS>
    </>
  );
};
